import { render } from "./App.vue?vue&type=template&id=37283659"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\canti\\OneDrive\\Escritorio\\proyectos\\importaciones\\wimportaciones\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__